import { type WithIsVisibleHOCProps } from "@client/hocs/withIsVisible";
import { connectCustom } from "@client/lib/misc";
import { makeLogoOptionsSelector, TargetSelector } from "@client/selectors";
import { type AppState } from "@client/types";
import Logo, { INVISIBLE_PROPS, type LogoProps } from "@client/widgets/Logo/component";
import { stickyCustomLogoSelector } from "../selectors";
import "./style.less";

const makeMapStateToProps = () => {
  const logoOptionsSelector = makeLogoOptionsSelector(TargetSelector.Layout, "header");
  const stickyLogoOptionsSelector = makeLogoOptionsSelector(TargetSelector.Layout, "header.sticky");

  return (state: AppState): LogoProps & WithIsVisibleHOCProps => {
    const logoOptions = logoOptionsSelector(state);

    if (state.widgets.header.isSearchBarVisible || !logoOptions) return INVISIBLE_PROPS;

    const options = state.widgets.header.isSticky
      ? stickyCustomLogoSelector(state)
        ? stickyLogoOptionsSelector(state)
        : logoOptions
      : logoOptions;
    if (!options) return INVISIBLE_PROPS;

    return {
      isVisible: true,
      options,
      preventRedirect: state.isEditMode
    };
  };
};

export default connectCustom(makeMapStateToProps)(Logo);
